import { Pipe, PipeTransform } from '@angular/core';
import { OrderedItem, IngredientChoice, OrderedItemService } from 'ngx-web-api';

@Pipe({
  name: 'dependencyMet',
})
export class DependencyMetPipe implements PipeTransform {
  constructor(private orderedItemService: OrderedItemService) {}

  transform(choice: IngredientChoice, item: OrderedItem): boolean {
    if (!!item && !!choice) {
      return this.orderedItemService.hasDependencyMet(item, choice);
    }
    return true;
  }
}
